
import { Link } from 'react-router-dom';
import Navbar from '../../components/feature/Navbar';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-purple-900">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-4xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-black text-white mb-4">
              Privacy Policy
            </h1>
            <p className="text-gray-400 text-lg">
              Last Updated: January 2025
            </p>
          </div>

          {/* Content */}
          <div className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-8 md:p-12 space-y-8">
            
            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-shield-user-line text-cyan-400"></i>
                1. Information We Collect
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                We collect information to provide better services to our users. The types of information we collect include:
              </p>
              
              <h3 className="text-xl font-semibold text-white mb-3 mt-6">Personal Information</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Name, email address, and contact information</li>
                <li>Government-issued ID for KYC verification</li>
                <li>Date of birth and nationality</li>
                <li>Residential address</li>
                <li>Phone number</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6">Financial Information</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Cryptocurrency wallet addresses</li>
                <li>Transaction history and trading activity</li>
                <li>Payment method information</li>
                <li>Account balances and holdings</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mb-3 mt-6">Technical Information</h3>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>IP address and device information</li>
                <li>Browser type and version</li>
                <li>Operating system</li>
                <li>Login timestamps and activity logs</li>
                <li>Cookies and similar tracking technologies</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-file-list-line text-cyan-400"></i>
                2. How We Use Your Information
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                We use the collected information for:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>Providing and maintaining our services</li>
                <li>Processing transactions and managing your account</li>
                <li>Verifying your identity (KYC/AML compliance)</li>
                <li>Preventing fraud and enhancing security</li>
                <li>Sending important notifications and updates</li>
                <li>Improving our platform and user experience</li>
                <li>Complying with legal and regulatory requirements</li>
                <li>Responding to customer support inquiries</li>
                <li>Marketing communications (with your consent)</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-lock-line text-cyan-400"></i>
                3. Data Security
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                We implement industry-standard security measures to protect your information:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li>End-to-end encryption for sensitive data</li>
                <li>Secure Socket Layer (SSL) technology</li>
                <li>Two-factor authentication (2FA)</li>
                <li>Regular security audits and penetration testing</li>
                <li>Cold storage for cryptocurrency assets</li>
                <li>Employee access controls and training</li>
                <li>24/7 security monitoring</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-user-settings-line text-cyan-400"></i>
                4. Your Rights
              </h2>
              <p className="text-gray-300 leading-relaxed mb-3">
                You have the right to:
              </p>
              <ul className="list-disc list-inside text-gray-300 space-y-2 ml-4">
                <li><strong>Access:</strong> Request a copy of your personal data</li>
                <li><strong>Correction:</strong> Update or correct inaccurate information</li>
                <li><strong>Deletion:</strong> Request deletion of your data (subject to legal requirements)</li>
                <li><strong>Portability:</strong> Receive your data in a structured format</li>
                <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
              </ul>
              <p className="text-gray-300 leading-relaxed mt-4">
                To exercise these rights, please contact us at privacy@pepcoin.com
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4 flex items-center gap-3">
                <i className="ri-mail-line text-cyan-400"></i>
                5. Contact Us
              </h2>
              <p className="text-gray-300 leading-relaxed mb-4">
                For privacy-related questions or concerns, contact us at:
              </p>
              <div className="space-y-2">
                <p className="text-cyan-400">Email: privacy@pepcoin.com</p>
                <p className="text-cyan-400">Data Protection Officer: dpo@pepcoin.com</p>
                <Link to="/contact" className="text-cyan-400 hover:text-cyan-300 inline-flex items-center gap-2 cursor-pointer">
                  Contact Form <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </section>

          </div>

          {/* Footer Actions */}
          <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/terms"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-file-text-line mr-2"></i>
              Terms & Conditions
            </Link>
            <Link
              to="/risk-disclosure"
              className="px-6 py-3 bg-white/10 border border-white/20 rounded-lg text-white font-medium hover:bg-white/20 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-alert-line mr-2"></i>
              Risk Disclosure
            </Link>
            <Link
              to="/"
              className="px-6 py-3 bg-gradient-to-r from-cyan-500 to-purple-600 rounded-lg text-white font-medium hover:scale-105 transition-all duration-300 text-center cursor-pointer whitespace-nowrap"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
